import { useCallback } from 'react';
import { TabList } from '@mui/lab';
import { Divider, Tab } from '@mui/material';

import type { OffersCarouselCategory } from '@ocx/data-offers';

import { CarouselScrollButton } from './carousel-scroll-button.component';

export type OffersCarouselHeaderProps = {
  categories: OffersCarouselCategory[];
  onCategoryChange: (nextCategoryId: string) => void;
};

export const OffersCarouselHeader = (props: OffersCarouselHeaderProps) => {
  const { categories, onCategoryChange } = props;

  const onChange = useCallback(
    (_: unknown, nextCategoryId: string) => {
      onCategoryChange(nextCategoryId);
    },
    [onCategoryChange],
  );

  if (categories.length < 2) {
    return null;
  }

  return (
    <>
      <TabList
        onChange={onChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons
        sx={{ position: 'relative' }}
        ScrollButtonComponent={CarouselScrollButton}
        allowScrollButtonsMobile>
        {categories.map(({ id, title }) => (
          <Tab sx={{ flexGrow: 1, maxWidth: 'none' }} key={id} value={id} label={title} />
        ))}
      </TabList>
      <Divider />
    </>
  );
};
